import React, { Dispatch, FC, Fragment, SyntheticEvent, forwardRef, useState } from "react";
import {
  Button, TableCell, TableRow, Stack, Dialog, DialogTitle,
  DialogActions, DialogContent, DialogContentText, Slide,
  Typography, ListItemText, List, ListItem, Card, CardContent,
  Accordion, AccordionSummary, AccordionDetails, Box, Divider,
} from "@mui/material";
import { cellStyle } from "../Pays/RowPays";
import { IBu } from "./Bu";
import DeleteIcon from "@mui/icons-material/Delete";
import { AxiosInstance } from "axios";
import { IPays } from "../Pays/Pays";
import { btnStyle } from "../user/Tabs/utilisateur/UtilisateurRow";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import OptionalWidthModal from "../../../../commons/optional-width-modal/OptionalWidthModal";
import BusinessUnitForm from "../../../forms/Bu/BusinessUnitForm";
import { AlertType } from "../../../../types/AlertType";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import LoadingButton from "@mui/lab/LoadingButton";
import { TransitionProps } from "@mui/material/transitions";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
interface buRowsAtribute {
  row: IBu;
  isDesktopOrLaptop: boolean;
  allPays: IPays[];
  http: AxiosInstance;
  reloadList: () => void;
  expanded: number | false;
  setExpanded: Dispatch<React.SetStateAction<number | false>>;
  setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
  setAlerteMessage: Dispatch<React.SetStateAction<string>>;
  setAlertType: Dispatch<React.SetStateAction<AlertType>>;
}

const BuRow: FC<buRowsAtribute> = ({
  row,
  isDesktopOrLaptop,
  allPays,
  http,
  expanded,
  setExpanded,
  reloadList,
  setOpenSnack,
  setAlerteMessage,
  setAlertType
}) => {
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);

  const handleValidate = () => {
    setDeleteLoading(true);
    http.get(`delete/bu/${row?.id}`)
      .then(() => {
        setAlerteMessage("Suppréssion efféctuée !");
        setAlertType("success");
        setOpenSnack(true);
        setOpenDialog(false);
        reloadList();
      }).catch((error) => {
        setAlertType("error");
        setOpenSnack(true);
        console.log(error.message);
      }).finally(() => {
        setDeleteLoading(false);
      });
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleDelete = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleChangeAccordionValue = (panel: number) => (event: SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const PaysText = () => {
    const tabFeatures: string[] = [];
    for (let pays of row?.pays) {
      tabFeatures.push(pays?.libelle);
    }

    return tabFeatures.join(' / ');
  }

  return (
    <Fragment>
      {isDesktopOrLaptop ? (
        <TableRow>
          <TableCell style={cellStyle} align="center">
            {row.libelle}
          </TableCell>
          <TableCell style={cellStyle} align="center">
            {PaysText()}
          </TableCell>
          <TableCell style={cellStyle} align="center">
            <Stack direction="row" spacing={2} display="flex" justifyContent="center">
              <Button
                size="small"
                variant="outlined"
                startIcon={<BorderColorIcon />}
                onClick={() => setOpenModal(true)}
                sx={btnStyle({
                  bgColor: "#070d23",
                  hoverColor: "Gray",
                  color: "#fff"
                })}
              >
                Modifier
              </Button>
              <Button
                color="warning"
                size="small"
                startIcon={<DeleteIcon />}
                onClick={() => handleDelete()}
                variant="contained"
                sx={btnStyle({
                  bgColor: "#FF0000",
                  hoverColor: "#FE3737",
                })}
              >
                Supprimer
              </Button>
            </Stack>
          </TableCell>
        </TableRow>
      ) : (
        <Accordion
          expanded={expanded === row?.id}
          onChange={handleChangeAccordionValue(row?.id as number)}
          sx={{
            borderRadius: 1,
            bgcolor: "#fff",
            mb: 1,
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "#080d24" }} />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Stack direction="column">
              <List sx={{ py: 0 }} dense>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary={
                      <Typography variant="caption" sx={{ color: '#080d24' }}>
                        {row?.libelle}
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            <Stack direction="column" spacing={1}>
              <Button
                variant="contained"
                sx={btnStyle({
                  bgColor: "Gray",
                  hoverColor: "Gray",
                  color: "#fff",
                })}
                size="small"
                fullWidth
                startIcon={<BorderColorIcon />}
                onClick={() => setOpenModal(true)}
              >
                Modifier
              </Button>

              <Button
                size="small"
                variant="contained"
                sx={btnStyle({
                  bgColor: "#FF0000",
                  hoverColor: "#FE3737",
                })}
                fullWidth
                startIcon={<DeleteIcon />}
                onClick={() => handleDelete()}
              >
                Supprimer
              </Button>

              <Box>
                <Typography
                  variant="h6"
                  sx={{ mt: 2, mb: 0 }}
                >
                  Pays
                </Typography>
                <Divider
                  orientation="horizontal"
                  sx={{ bgcolor: "#fff", mb: 1 }}
                />
              </Box>

              <Card>
                <CardContent>
                  <List dense>
                    {row?.pays?.map(elem => (
                      <Fragment key={elem?.id}>
                        <ListItem dense>
                          <ListItemText
                            primary={
                              <Typography key={elem?.id} sx={{ fontSize: 11 }}>
                                {`- ${elem?.libelle}`}
                              </Typography>
                            }
                          />
                        </ListItem>
                        <Divider
                          orientation="horizontal"
                          sx={{ bgcolor: "#EAE9E9" }}
                        />
                      </Fragment>
                    ))}
                  </List>
                </CardContent>
              </Card>
            </Stack>
          </AccordionDetails>
        </Accordion>
      )}

      <OptionalWidthModal
        title="Modifier un BU"
        onClose={handleClose}
        open={openModal}
      >
        <BusinessUnitForm
          allPays={allPays}
          http={http}
          rowBu={row}
          reloadList={reloadList}
          onClose={handleClose}
          setOpenSnack={setOpenSnack}
          setAlerteMessage={setAlerteMessage}
          setAlertType={setAlertType}
        />
      </OptionalWidthModal>

      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleCloseDialog()}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Vous êtes sur le point de supprimer ce BU,
            êtes-vous sûr de vouloir poursuivre cette action ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            onClick={() => handleValidate()}
            startIcon={<DeleteIcon />}
            loading={deleteLoading}
            loadingPosition="end"
            sx={btnStyle({
              bgColor: "#FF0000",
              hoverColor: "#FE3737"
            })}
            variant="contained"
          >
            Oui
          </LoadingButton>
          <LoadingButton
            onClick={() => handleCloseDialog()}
            startIcon={<ExitToAppIcon />}
            sx={{ textTransform: "none" }}
            loadingPosition="end"
            variant="contained"
            color="inherit"
          >
            Non
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default BuRow;
